import React from "react";
import SpLogo from "../../SVGs/SpLogo";
import { onClickType } from "src/assets/Types/Redesign/PrimaryNavMenuType.type";

type LogoContainerProps = {
  className?: string;
  onClick: onClickType;
};

const LogoContainer: React.FC<LogoContainerProps> = ({
  className,
  onClick,
  ...rest
}) => {
  return (
    <div
      className={`flex items-center justify-center h-9 w-[189.391px] ${className}`}
      {...rest}
    >
      <a
        onClick={onClick}
        href="/"
        className="h-9"
        aria-label="Simplepractice Logo"
      >
        <SpLogo />
      </a>
    </div>
  );
};

export default LogoContainer;
